import React from "react";
import qrDemo from "../../../assets/svg/my brand/qr-demo.png";

/**
 * Stand-in QR. It is decorative — a specimen of a code rather than a rendering
 * of the UPI details above it, so it never redraws while the form is being
 * typed into. A real payable code arrives when the dietitian uploads one,
 * which is what `src` renders.
 */
const PlaceholderQr: React.FC = () => (
  <img
    src={qrDemo}
    alt="Payment QR code placeholder"
    className="w-full h-full object-contain"
  />
);

interface PaymentQrProps {
  /** Data URL of an uploaded QR, when there is one. */
  src?: string;
  className?: string;
}

const PaymentQr: React.FC<PaymentQrProps> = ({ src, className = "" }) => {
  // An uploaded QR that will not load falls back to the demo one rather than
  // to a broken icon — this sits on an invoice, where a missing square is read
  // as "this cannot be paid". Keyed by the src that failed, so a newly picked
  // QR is tried afresh.
  const [failedSrc, setFailedSrc] = React.useState<string | null>(null);

  return (
    <div className={className}>
      {src && failedSrc !== src ? (
        <img
          src={src}
          alt="Payment QR code"
          className="w-full h-full object-contain"
          onError={() => setFailedSrc(src)}
        />
      ) : (
        <PlaceholderQr />
      )}
    </div>
  );
};

export default PaymentQr;
